import { render, staticRenderFns } from "./StockOnHandManager.vue?vue&type=template&id=2ebe4ba9&"
import script from "./StockOnHandManager.vue?vue&type=script&lang=js&"
export * from "./StockOnHandManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockOnHandManager.vue"
export default component.exports